import React from 'react';
import { Instagram } from 'lucide-react';

const InstagramFeed = () => {
  // Professional Instagram showcase images
  const instagramImages = [
    { 
      id: 1, 
      image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/e11rz970_Photo%20Apr%2014%202026%2C%208%2021%2043%20PM.jpg',
      alt: 'Hair styling - back view'
    },
    { 
      id: 2, 
      image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/1jgm42pi_Photo%20Apr%2014%202026%2C%208%2022%2000%20PM.jpg',
      alt: 'Makeup artistry close-up'
    },
    { 
      id: 3, 
      image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/el5nyiue_Photo%20Apr%2014%202026%2C%208%2022%2018%20PM.jpg',
      alt: 'Glamorous makeup look'
    },
    { 
      id: 4, 
      image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/zsui0evo_Photo%20Apr%2014%202026%2C%208%2022%2045%20PM.jpg',
      alt: 'Hair styling - side view'
    },
    { 
      id: 5, 
      image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/we8wb3ie_Photo%20Mar%2021%202026%2C%209%2007%2010%20AM.jpg',
      alt: 'Professional makeup application'
    }
  ];

  return (
    <section className="px-12 lg:px-20 py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-light text-black tracking-wide mb-6 sm:mb-8">
            As Seen On
          </h2>
          <div className="w-12 h-px bg-black mx-auto mb-6 sm:mb-8"></div>
          <a
            href="https://www.instagram.com/laugonzalez.mua?igsh=YmJ3eW1pcnZtd3V5&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[10px] tracking-[2px] uppercase font-light text-black hover:opacity-60 transition-opacity"
          >
            <Instagram size={16} strokeWidth={1} />
            @laugonzalez.mua
          </a>
        </div>

        {/* Instagram Grid - Professional Image Gallery */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 lg:gap-4 max-w-6xl mx-auto">
          {instagramImages.map((item) => (
            <div
              key={item.id}
              className="aspect-square bg-white border border-black/10 hover:border-black/30 transition-all duration-300 group relative overflow-hidden"
            >
              <img
                src={item.image}
                alt={item.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              {/* Subtle hover overlay */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors"></div>
            </div>
          ))}
        </div>

        {/* Follow CTA */}
        <div className="text-center mt-10 sm:mt-12">
          <a
            href="https://www.instagram.com/laugonzalez.mua?igsh=YmJ3eW1pcnZtd3V5&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 px-12 py-5 border border-black text-black text-[10px] tracking-[2px] uppercase font-light hover:bg-black hover:text-white transition-all duration-300"
          >
            <Instagram size={16} strokeWidth={1} />
            Follow on Instagram
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
